import { render, staticRenderFns } from "./CustomerContextMenu.vue?vue&type=template&id=0646c046&scoped=true&"
import script from "./CustomerContextMenu.vue?vue&type=script&lang=js&"
export * from "./CustomerContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./CustomerContextMenu.vue?vue&type=style&index=0&id=0646c046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0646c046",
  null
  
)

export default component.exports